import AttributeItem from './attributeItem';
import A from './attributes';
import { boolToString } from '../../../utils/formater';
import {HAS, IS, UNSPECIFIED, CASES} from '../../../consts';
import Storeys from '../../common/storeys';

class AttributeStore {
  constructor (property) {
    this.item = property;

    this.property = this.item.getProperty();
    this.building = this.property.getBuilding();
    this.room = this.property.getRoom();
    this.landPlot = this.property.getLandPlot();
    this.infrastructure = this.property.getInfrastructure();
    this.dealCondition = this.item.getDealCondition();
  }

  /**
   * Группы характеристик
   * @returns {array}
   */
  getAttributes () {
    return [
      {
        title: 'Параметры',
        items: []
      }
    ];
  }

  getCase (caseName = CASES.GENITIVE, isSingular = true) {
    return this.property.getTypeCase().getIn([isSingular ? CASES.SINGULAR : CASES.PLURAL, caseName], '');
  }

  /**
   * Атрибут для условия логического условия да/нет
   * @param label
   * @param value
   * @returns {AttributeItem}
   */
  getIs (label, value) {
    return new AttributeItem(label, boolToString(value, IS));
  }

  /**
   * Атрибут для условия логического условия есть/нет
   * @param label
   * @param value
   * @returns {AttributeItem}
   */
  getHas (label, value) {
    return new AttributeItem(label, boolToString(value, HAS));
  }

  /**
   * Атрибут для условия логического условия есть/нет
   * @param label
   * @param dictionary
   * @returns {AttributeItem}
   */
  getDictionaryUnit (label, dictionary) {
    const value = dictionary ? dictionary.get('fullName') : UNSPECIFIED;
    return new AttributeItem(label, value);
  }

  // ------

  /**
   * Можно с животными
   * @returns {AttributeItem}
   */
  getAnimalAllowed () {
    return this.getIs(A.ANIMALS_ALLOWED, this.dealCondition.isAnimals());
  }

  /**
   * Счетчик воды
   * @returns {AttributeItem}
   */
  getWaterMeter () {
    return this.getHas(A.WATER_METER, this.room.hasWaterMeter());
  }

  /**
   * Балкон/лоджия
   * @returns {AttributeItem}
   */
  getBalcony () {
    return this.getDictionaryUnit(A.BALCONY, this.room.getBalcony());
  }

  /**
   * Баня
   * @returns {AttributeItem}
   */
  getBathhouse () {
    return this.getHas(A.BATHHOUSE, this.infrastructure.hasBathhouse());
  }

  /**
   * Тип дома
   * @returns {AttributeItem}
   */
  getBuildingType () {
    return this.getDictionaryUnit(A.BUILDING_TYPE, this.building.getType());
  }

  /**
   * Канализация
   * @returns {AttributeItem}
   */
  getCanalization () {
    return this.getHas(A.CANALIZATION, this.building.hasCanalization());
  }

  /**
   * Высота потолка
   * @returns {AttributeItem}
   */
  getCeilingHeight () {
    const value = this.room.getCeilingHeight();
    return new AttributeItem(A.CEILING_HEIGHT, value || UNSPECIFIED);
  }

  /**
   * Можно с детьми
   * @returns {AttributeItem}
   */
  getChildAllowed () {
    return this.getIs(A.CHILDREN_ALLOWED, this.dealCondition.isChildren());
  }

  /**
   * Кондиционер
   * @returns {AttributeItem}
   */
  getConditioning () {
    return this.getHas(A.CONDITIONING, this.room.hasConditioning());
  }

  /**
   * Угловая
   * @returns {AttributeItem}
   */
  getCorner () {
    return this.getIs(A.CORNER, this.room.isCorner());
  }

  /**
   * Срок сдачи/Год постройки
   * @returns {AttributeItem}
   */
  getYearBuild () {
    const label = this.building.getIsBuild() ? A.YEAR_OF_CONSTRUCTION : A.DEADLINE;
    const value = this.building.getDeliveryDateShortLabel();

    return new AttributeItem(label, value || UNSPECIFIED);
  }

  /**
   * Отдельностоящее здание
   * @returns {AttributeItem}
   */
  getDetachedBuilding () {
    return this.getIs(A.DETACHED_BUILDING, this.building.isDetached());
  }

  /**
   * Электричество
   * @returns {AttributeItem}
   */
  getElectricity () {
    return this.getHas(A.ELECTRICITY, this.building.hasElectricity());
  }

  /**
   * Лифт
   * @returns {AttributeItem}
   */
  getElevator () {
    return this.getHas(A.ELEVATOR, this.building.hasElevator());
  }

  /**
   * Первая линия
   * @returns {AttributeItem}
   */
  getFirstLine () {
    return this.getIs(A.FIRST_LINE, this.building.isFirstLine());
  }

  /**
   * Этаж
   * @returns {AttributeItem}
   */
  getFloor () {
    const storeys = new Storeys(this.room.getFloorNumber(), this.building.getFloorsNumberAboveGround());

    return new AttributeItem(A.FLOOR, storeys.getLabel(Storeys.TYPE_SMALL));
  }

  /**
   * Кол-во этажей
   * @returns {AttributeItem}
   */
  getFloorTotal () {
    return new AttributeItem(A.FLOOR_TOTAL, this.building.getFloorsNumberAboveGround());
  }

  /**
   * Покрытие пола
   * @returns {AttributeItem}
   */
  getFloorCovering () {
    return this.getDictionaryUnit(A.FLOOR_COVERING, this.room.getFloorCovering());
  }

  /**
   * Холодильник
   * @returns {AttributeItem}
   */
  getFridge () {
    return this.getHas(A.FRIDGE, this.room.hasFridge());
  }

  /**
   * Мебель
   * @returns {AttributeItem}
   */
  getFurniture () {
    return this.getDictionaryUnit(A.FURNITURE, this.room.getFurniture());
  }

  /**
   * Гараж
   * @returns {AttributeItem}
   */
  getGarage () {
    return this.getHas(A.GARAGE, this.infrastructure.hasGarage());
  }

  /**
   * Газ
   * @returns {AttributeItem}
   */
  getGas () {
    return this.getHas(A.GAS, this.building.hasGas());
  }

  /**
   * Вид отопления
   * @returns {AttributeItem}
   */
  getHeating () {
    return this.getDictionaryUnit(A.HEATING, this.building.getHeating());
  }

  /**
   * Наличие отопления - для рубрики гаражей
   * @returns {AttributeItem}
   */
  getHasHeating () {
    return this.getHas(A.HEATING, this.building.hasHeating());
  }

  /**
   * Домофон
   * @returns {AttributeItem}
   */
  getIntercom () {
    return this.getHas(A.INTERCOM, this.building.hasIntercom());
  }

  /**
   * Интернет
   * @returns {AttributeItem}
   */
  getInternet () {
    return this.getHas(A.INTERNET, this.room.hasInternet());
  }

  /**
   * Материал дома
   * @returns {AttributeItem}
   */
  getMaterial () {
    return this.getDictionaryUnit(A.MATERIAL, this.building.getMaterial());
  }

  /**
   * Новостройка
   * @returns {AttributeItem}
   */
  getNewBuilding () {
    return this.getIs(A.NEW_BUILDING, this.building.isNewBuilding());
  }

  /**
   * Новый дом
   * @returns {AttributeItem}
   */
  getNewHouse () {
    return this.getIs(A.NEW_HOUSE, this.building.isNewBuilding());
  }

  /**
   * Кол-во спальных мест
   * @returns {AttributeItem}
   */
  getNumberOfBeds () {
    const value = this.room.getNumberOfBeds();
    return new AttributeItem(A.NUMBER_OF_BEDS, value || UNSPECIFIED);
  }

  /**
   * Хоз. постройки
   * @returns {AttributeItem}
   */
  getOutbuildings () {
    return this.getHas(A.OUTBUILDINGS, this.infrastructure.hasOutbuildings());
  }

  /**
   * Входная дверь
   * @returns {AttributeItem}
   */
  getOuterDoor () {
    return this.getDictionaryUnit(A.OUTER_DOOR_TYPE, this.room.getOuterDoorType());
  }

  /**
   * Отдельный вход
   * @returns {AttributeItem}
   */
  getPrivateEntrance () {
    return this.getIs(A.OWN_ENTRANCE, this.room.isPrivateEntrance());
  }

  /**
   * Парковка
   * @returns {AttributeItem}
   */
  getParking () {
    return this.getDictionaryUnit(A.PARKING_TYPE, this.infrastructure.getParking());
  }

  /**
   * Парковка
   * @returns {AttributeItem}
   */
  getProtectedParking () {
    return this.getHas(A.PROTECTED_PARKING, this.infrastructure.hasProtectedParking());
  }

  /**
   * Планировка
   * @returns {AttributeItem}
   */
  getPlaning () {
    return this.getDictionaryUnit(A.PLANNING, this.room.getPlanning());
  }

  /**
   * Состояние/ремонт
   * @returns {AttributeItem}
   */
  getRenovation () {
    return this.getDictionaryUnit(A.RENOVATION_TYPE, this.room.getRenovation());
  }

  /**
   * Период сдачи в аренду
   * @returns {AttributeItem}
   */
  getRentPeriod () {
    return this.getDictionaryUnit(A.RENT_PERIOD, this.dealCondition.getRentPeriod());
  }

  /**
   * Мусоропровод
   * @returns {AttributeItem}
   */
  getRubbishChute () {
    return this.getHas(A.RUBBISH_CHUTE, this.building.hasRubbishChute());
  }

  /**
   * Санузел
   * @returns {AttributeItem}
   */
  getSanitary () {
    return this.getDictionaryUnit(A.SANITARY, this.room.getSanitary());
  }

  /**
   * Охрана
   * @returns {AttributeItem}
   */
  getSecurityProtection () {
    return this.getHas(A.SECURITY_PROTECTION, this.infrastructure.hasSecurityProtection());
  }

  /**
   * Площадь дома
   * @returns {AttributeItem}
   */
  getSquareHouse () {
    const area = this.room.getTotalArea();
    return new AttributeItem(A.SQUARE_HOUSE, area ? area.getLabel(false) : UNSPECIFIED);
  }

  /**
   * Площадь кухни
   * @returns {AttributeItem}
   */
  getSquareKitchen () {
    const area = this.room.getKitchenArea();
    return new AttributeItem(A.SQUARE_KITCHEN, area ? area.getLabel(false) : UNSPECIFIED);
  }

  /**
   * Площадь участка
   * @returns {AttributeItem}
   */
  getSquareLand () {
    const area = this.landPlot.getTotalArea();
    return new AttributeItem(A.SQUARE_LAND, area ? area.getLabel(false) : UNSPECIFIED);
  }

  /**
   * Площадь жилая
   * @returns {AttributeItem}
   */
  getSquareLiving () {
    const area = this.room.getLivingArea();
    return new AttributeItem(A.SQUARE_LIVING, area ? area.getLabel(false) : UNSPECIFIED);
  }

  /**
   * Площадь общая
   * @returns {AttributeItem}
   */
  getSquareTotal () {
    const area = this.room.getTotalArea();
    return new AttributeItem(A.SQUARE_TOTAL, area ? area.getLabel(false) : UNSPECIFIED);
  }

  /**
   * Количество человек
   * @returns {AttributeItem}
   */
  getPersonCount () {
    return this.getDictionaryUnit(A.PERSON_COUNT, this.dealCondition.getPersonCount());
  }

  /**
   * Предпочтение к жильцам
   * @returns {AttributeItem}
   */
  getGenderPreference () {
    return this.getDictionaryUnit(A.GENDER_PREFERENCE, this.dealCondition.getGenderPreference());
  }

  /**
   * Телевизор
   * @returns {AttributeItem}
   */
  getTV () {
    return this.getHas(A.TV, this.room.hasTV());
  }

  /**
   * Категория использования
   * @returns {AttributeItem}
   */
  getUsageCategory () {
    return this.getDictionaryUnit(A.USAGE_CATEGORY, this.landPlot.getUsageCategory());
  }

  /**
   * Стиральная машина
   * @returns {AttributeItem}
   */
  getWashingMachine () {
    return this.getHas(A.WASHING_MACHINE, this.room.hasWashingMachine());
  }

  /**
   * Водопровод
   * @returns {AttributeItem}
   */
  getWater () {
    return this.getHas(A.WATER, this.building.hasWater());
  }

  /**
   * Материал окон
   * @returns {AttributeItem}
   */
  getWindowType () {
    return this.getDictionaryUnit(A.WINDOW_TYPE, this.room.getWindowType());
  }

  /**
   * Вид из окон
   * @returns {AttributeItem}
   */
  getWindowView () {
    return this.getDictionaryUnit(A.WINDOW_VIEW, this.room.getWindowView());
  }

  /**
   * Смотровая яма
   * @returns {AttributeItem}
   */
  getRepairPit () {
    return this.getHas(A.REPAIR_PIT, this.building.hasRepairPit());
  }

  /**
   * Погреб
   * @returns {AttributeItem}
   */
  getCellar () {
    return this.getHas(A.CELLAR, this.building.hasCellar());
  }

  /**
   * Размеры
   * @returns {AttributeItem}
   */
  getSizes () {
    return new AttributeItem(A.SIZES, this.building.getSizeLabel());
  }

  /**
   * Ориентир
   * @returns {AttributeItem}
   */
  getReference () {
    const location = this.property.getGeoLocation();
    const value = location ? location.getReference() : null;
    return new AttributeItem(A.REFERENCE, value || UNSPECIFIED);
  }

  /**
   * Удаленность от города
   * @returns {AttributeItem}
   */
  getDistanceFromCity () {
    const location = this.property.getGeoLocation();
    const value = location ? location.getDistanceFromCity() : null;
    return new AttributeItem(A.DISTANCE_FROM_CITY, value || UNSPECIFIED);
  }
}

export default AttributeStore;



// WEBPACK FOOTER //
// ./src/classes/announcement/attributes/attributeStore.js